<template>
  <div class="mainHeader">
    <div class="nav">
      <img src="../../assets/images/student/back.png" alt="" width="50" @click="returnBack(path)">
    </div>
    <!-- 学习之旅页面展示白色图标 -->
    <div class="main">
      <el-dropdown trigger="click" @command="returnLogin" :hide-on-click="false">
        <div class="el-dropdown-link">
          <img src="../../assets/images/student/mine.png" alt="">
          <span>
            {{ $store.state.userInfo.realname }} <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
        </div>
        <template>
          <el-dropdown-menu>
            <el-dropdown-item command="20">设置</el-dropdown-item>
            <el-dropdown-item command="10">退出登录</el-dropdown-item>
            <el-dropdown-item command="0">刷新页面</el-dropdown-item>
            <el-dropdown-item command="5">内核测试</el-dropdown-item>
            <el-dropdown-item command="1">高速通道</el-dropdown-item>

          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <Exitpopup :exit_data="exit_data"/>
  </div>
</template>

<script>
import {browserUrl} from '@/utils/index.js'

export default {
  components: {
    Exitpopup: (resolve) => {
      require(['@/components/student/exitpopup.vue'], resolve)
    }
  },
  name: 'mainHeader',
  props: {
    path: {
      type: String,
      default: '/home'
    }
  },
  data() {
    return {
      browserUrl: browserUrl, // 退出登陆地址
      exit_data: { // 控制退出登录弹窗显示隐藏
        isShow: false
      }
    }
  },
  methods: {
    // 退出登录
    returnLogin(command) {
      if (command == 10) {
        this.exit_data.isShow = true
      } else if (command == 20) {
        if (this.$route.name === 'testpage' || this.$route.name === 'study') {
          this.$message.warning('当前为学习时间，请勿前往个人中心')
        } else {
          this.$router.replace({path: '/setUpPage/information'})
        }
      } else if (command == 5) {
        window.open('https://liulanmi.com/labs/core.html', '_blank');
      } else if(command == 1){
        window.open('https://debugtbs.qq.com', '_blank');
      }else{
        window.location.reload();
      }
    },


    returnBack(val) {
      const backRouteNames = ['study', 'testpage', 'afterStudy', 'afterTestpage', 'afterReviewStudy', 'afterReviewTestpage']
      if (backRouteNames.includes(this.$route.name)) {
        this.$emit('back')
      } else {
        this.$router.replace({path: `${val}`})
      }
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.mainHeader {
  height: 90px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1999;
}

.el-icon--right {
  display: none;
}

.main {
  position: absolute;
  top: 23px;
  right: 40px;
  color: #fff;
  font-size: 26px;
  cursor: pointer;
  padding-left: 65px;
  line-height: 50px;
  animation-delay: 0.6s;
  letter-spacing: 2px;

  img {
    display: block;
    float: left;
    width: 50px;
    height: 50px;
  }

  span {
    display: block;
    float: left;
    margin-left: 10px;
  }
}

.nav {
  position: absolute;
  top: 14px;
  left: 40px;
  overflow: hidden;
  color: #fff;

  img {
    display: block;
    width: 70px;
    height: 70px;
    float: left;
    cursor: pointer;
  }
}

.main {
  .el-dropdown {
    color: #333;
    font-size: 24px;
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 1024px) {
  .mainHeader {
    height: 60px;
  }

  .nav {
    top: 10px;
    left: 15px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .main {
    top: 12px;
    right: 15px;
    font-size: 14px;
    line-height: 36px;
    padding-left: 0;

    img {
      width: 30px;
      height: 30px;
    }

    span {
      margin-left: 6px;
      font-size: 14px;
    }

    .el-dropdown {
      font-size: 14px;
    }
  }
}
</style>
